import { deepMerge } from '@antfu/utils'
import { createI18n } from 'vue-i18n'
import { ar as officialAr, en as officialEn, fr as officialFr } from 'vuetify/locale'
import { cookieRef } from '@layouts/stores/config'
import { themeConfig } from '@themeConfig'

const officialVuetifyMessages = {
  ar: officialAr,
  en: officialEn,
  fr: officialFr,
}

export const mergeLocaleMessages = (locale, applicationMessages) =>
  deepMerge(
    { $vuetify: deepMerge({}, officialVuetifyMessages[locale] ?? officialVuetifyMessages.en) },
    applicationMessages
  )

const messages = Object.fromEntries(
  Object.entries(import.meta.glob('./locales/*.json', { eager: true })).map(([key, value]) => {
    const locale = key.slice(10, -5)

    return [locale, mergeLocaleMessages(locale, value.default)]
  })
)

let _i18n = null
export const getI18n = () => {
  if (_i18n === null) {
    _i18n = createI18n({
      legacy: false,
      locale: cookieRef('language', themeConfig.app.i18n.defaultLocale).value,
      fallbackLocale: 'en',
      messages,
    })
  }

  return _i18n
}
export default function (app) {
  app.use(getI18n())
}
